import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20technology%20community%20abstract%20background%20with%20warm%20orange%20and%20teal%20geometric%20patterns%2C%20soft%20gradient%20overlay%2C%20minimalist%20digital%20art%20style%2C%20clean%20and%20professional%20atmosphere%2C%20connected%20nodes%20and%20network%20visualization%20in%20subtle%20patterns&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt="草榴技术讨论区"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full max-w-[900px] mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
          草榴技术讨论区
        </h1>
        <p className="text-base md:text-xl text-white/85 max-w-[650px] mx-auto mb-8 leading-relaxed">
          专注技术交流的核心社区，汇聚编程开发、网络技术、工具软件等实用经验
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/programming"
            className="px-8 py-3 bg-primary-500 text-white rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            开始探索
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/15 backdrop-blur-sm text-white border border-white/25 rounded-full text-sm font-semibold hover:bg-white/25 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            了解社区
          </Link>
        </div>

        <div className="mt-10 flex items-center justify-center gap-8 text-white/60 text-sm">
          <div className="text-center">
            <div className="text-2xl font-bold text-white">12,580+</div>
            <div className="mt-1">技术文章</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl font-bold text-white">68,420+</div>
            <div className="mt-1">社区成员</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl font-bold text-white">6</div>
            <div className="mt-1">技术分类</div>
          </div>
        </div>
      </div>
    </section>
  );
}